const pt = {
    "Bem-vindo à Assembleia Nacional":"Bem-vindo à Assembleia Nacional",
    "Continuar":"Continuar",
    "Escolha seu Idioma":"Escolha seu Idioma",
    "O Palácio da Assembleia Nacional":"O Palácio da Assembleia Nacional",
    "História da Assembleia":"História da Assembleia",
    "Galeria":"Galeria",
    "Quiz":"Quiz",
    "Símbolos":"Símbolos",
    "Visita Virtual":"Visita Virtual",
    "Constituição":"Constituição",
    "Teste seus conhecimentos acerca da Assembleia, Parlamento, Constituição e a República":"Teste seus conhecimentos acerca da Assembleia, Parlamento, Constituição e a República",
    "Modo":"Modo",
    "Jogar":"Jogar",
    "15 segundos":"15 segundos",
    "Clássico":"Clássico",
    "sem registros":"sem registros",
    "sair":"sair",
    "pontos":"pontos",
    "Tema":"Tema",
    "Parabens acertaste todas as nossas questões":"Parabéns acertaste todas as nossas questões",
    "Tempo esgotado":"Tempo esgotado",
    "Resposta errada":"Resposta errada",
    "Fim do Quiz":"Fim do Quiz",
    "Total de Pontos":"Total de Pontos",
    "Novo Record":"Novo Record",
    "seu nome":"seu nome",
    "salvar":"salvar",
    "responder novamente":"responder novamente",
    "lugar":"lugar",
    "Por favor degite seu nome":"Por favor degite seu nome",
    "Atuais":"Atuais",
    "Antigos":"Antigos",
    "Autor":"Autor",
    "Compositor":"Compositor",
    "Este browser não suporta audio":"Este browser não suporta audio",
    "letra":"letra",
    "Título":"Título",
    "descrição":"descrição",
    "Bandeira":"Bandeira",
    "Hino":"Hino",
    "Armas":"Armas",
    "Bandeira (1975-1992)":"Bandeira (1975-1992)",
    "Hino (1975-1992)":"Hino (1975-1992)",
    "Armas (1975-1992)":"Armas (1975-1992)",
    "Constituição da República":"Constituição da República",
    "fotos":"fotos",
    "Carregando":"Carregando",
    "procurar por artigos":"procurar por artigos",
    "procurar":"procurar",
    "Nenhum resultado encontrado":"Nenhum resultado encontrado",
    "voltar":"voltar",
    "Por favor degite um valor válido":"Por favor degite um valor válido"
}

export default pt;